<span class="element"
  [ngClass]="{'consume' :element.state == ElementState.consumed || element.state == ElementState.partlyConsumed}">
  <ghs-element-icon [element]="element"></ghs-element-icon>
  <ghs-pointer-input (singleClick)="toggleElement()" (doubleClick)="toggleElement(true)"></ghs-pointer-input>
</span>